import React from 'react'
import theme from './theme/index'
import CssBaseline from '@material-ui/core/CssBaseline'
import {
  MuiThemeProvider,
  StylesProvider,
  createGenerateClassName,
} from '@material-ui/core/styles'
import { ApolloProvider } from '../../src/providers/index'

// disableGlobal: true scope-a los nombres de clase de MUI v4 (JSS) para que no
// choquen con los de MUI v5 (que usa los mismos nombres globales, p.ej.
// .MuiButtonBase-root). Sin esto, el reset global de v4 (border: 0) pisa los
// botones de v5 en el build de producción y salen sin estilo. seed garantiza
// unicidad. Es la config recomendada por MUI para correr v4 y v5 en paralelo.
const generateClassName = createGenerateClassName({
  disableGlobal: true,
  productionPrefix: 'oky',
  seed: 'v4',
})

const wrapRootElement = ({ element }) => {
  return (
    <ApolloProvider>
      <StylesProvider generateClassName={generateClassName}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          {element}
        </MuiThemeProvider>
      </StylesProvider>
    </ApolloProvider>
  )
}

export default wrapRootElement
